import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CameraOffIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L3.58579 5H3C1.34315 5 0 6.34315 0 8V19C0 20.6569 1.34315 22 3 22H20.5858L22.2929 23.7071C22.6834 24.0976 23.3166 24.0976 23.7071 23.7071C24.0976 23.3166 24.0976 22.6834 23.7071 22.2929L16.0013 14.587C15.9926 14.578 15.9836 14.5691 15.9745 14.5603L10.4397 9.02547C10.4309 9.01636 10.422 9.00745 10.4129 8.99873L1.70711 0.292893ZM8.26209 9.6763L5.58579 7H3C2.44772 7 2 7.44772 2 8V19C2 19.5523 2.44772 20 3 20H18.5858L15.3237 16.7379C14.1638 17.7818 12.5593 18.2406 10.9854 17.9215C9.01649 17.5223 7.47771 15.9835 7.07854 14.0146C6.75944 12.4407 7.21818 10.8362 8.26209 9.6763ZM13.9061 15.3204L9.67964 11.0939C9.10241 11.7825 8.8544 12.7084 9.03866 13.6172C9.27816 14.7986 10.2014 15.7218 11.3828 15.9613C12.2916 16.1456 13.2175 15.8976 13.9061 15.3204ZM9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H14.4648L16.1679 6.5547C16.3534 6.8329 16.6656 7 17 7H21C21.5523 7 22 7.44772 22 8V17.34C22 17.8923 22.4477 18.34 23 18.34C23.5523 18.34 24 17.8923 24 17.34V8C24 6.34315 22.6569 5 21 5H17.5352L15.8321 2.4453C15.6466 2.1671 15.3344 2 15 2H9Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CameraOffIcon = assignWithoutSideEffects(_CameraOffIcon, {
  componentId: 'CameraOffIcon',
});

export default CameraOffIcon;
